import React, { useContext } from 'react'
import Provider, { Top5ContextProvider } from './Provider'
import { Box } from '@material-ui/core'
import { IProps } from './Interface'
import { useTheme } from '@material-ui/core/styles'
import { WordBankSelect } from 'smart-components'
import { WordBankCategory, IWordBank } from 'types'
import { Section, AsyncResponsesLoading } from 'components'

const Top5Page: React.FC<IProps> = ({ disabled }) => {
  const {
    state: { wordBanks, userWordbanks, rules },
    handlers: { canAddNewTag, handleTagClick, handleAddOwnClick }
  } = useContext(Top5ContextProvider)
  const theme = useTheme()

  return (
    <Section padding="30px 70px 30px 40px" direction="column">
      <Box pb={3} width="100%">
        <WordBankSelect
          disabled={disabled}
          wordBanks={wordBanks.companyDescriptor}
          title="I thrive in environments that are"
          category={WordBankCategory.CompanyDescriptor}
          canAddNewTag={() => canAddNewTag(WordBankCategory.CompanyDescriptor)}
          selectedWordBanks={(userWordbanks.companyDescriptor || []).map(tag => tag._id)}
          maxTagsNum={rules[WordBankCategory.CompanyDescriptor].maxItems}
          handleWordBankClick={(wordbank: IWordBank) => handleTagClick(wordbank)}
          handleAddOwnClick={wordbank =>
            handleAddOwnClick({
              wordbank: { ...wordbank, category: WordBankCategory.CompanyDescriptor }
            })
          }
        />
      </Box>
      <Box pb={3} width="100%">
        <WordBankSelect
          disabled={disabled}
          wordBanks={wordBanks.xfactor}
          category={WordBankCategory.Xfactor}
          color={theme?.palette?.common?.orange}
          title="My team members and friends say I am"
          canAddNewTag={() => canAddNewTag(WordBankCategory.Xfactor)}
          selectedWordBanks={(userWordbanks.xfactor || []).map(tag => tag._id)}
          maxTagsNum={rules[WordBankCategory.Xfactor].maxItems}
          handleWordBankClick={(wordbank: IWordBank) => handleTagClick(wordbank)}
          handleAddOwnClick={wordbank =>
            handleAddOwnClick({
              wordbank: { ...wordbank, category: WordBankCategory.Xfactor }
            })
          }
        />
      </Box>
      <Box pb={3} width="100%">
        <WordBankSelect
          disabled={disabled}
          wordBanks={wordBanks.talentTags}
          title="Facts about me & my pursuits"
          category={WordBankCategory.TalentTags}
          color={theme?.palette?.common?.lightBlue}
          canAddNewTag={() => canAddNewTag(WordBankCategory.TalentTags)}
          selectedWordBanks={(userWordbanks.talentTags || []).map(tag => tag._id)}
          maxTagsNum={rules[WordBankCategory.TalentTags].maxItems}
          handleWordBankClick={(wordbank: IWordBank) => handleTagClick(wordbank)}
          handleAddOwnClick={wordbank =>
            handleAddOwnClick({
              wordbank: { ...wordbank, category: WordBankCategory.TalentTags }
            })
          }
        />
      </Box>
    </Section>
  )
}

export default React.memo((props: IProps) => (
  <Provider {...props}>
    <AsyncResponsesLoading>
      <Top5Page {...props} />
    </AsyncResponsesLoading>
  </Provider>
))
